import useAuthStore from "@/store/useAuthStore";
import { Button, Select } from "@mantine/core";
import React, { useState, useEffect } from "react";
import useSWR from "swr";

export default function CompanySelector({ form, noLabel = false, ...rest }) {
  const companyList = useAuthStore((s) => s.companyList);

  return (
    <Select
      label={noLabel ? "" : "거래처"}
      placeholder="거래처"
      searchable
      clearable
      nothingFound="일치하는 항목 없음"
      {...form.getInputProps("company")}
      data={companyList.map((company) => ({ value: company.id, label: company?.attributes?.name }))}
      {...rest}
    />
  );
}
